import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-load-more-button',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    MatProgressSpinnerModule,
    ButtonComponent
  ],
  templateUrl: './load-more-button.component.html',
  styleUrls: ['./load-more-button.component.scss']
})
export class LoadMoreButtonComponent {
  /**
   * Total number of items available
   */
  @Input() totalItems: number = 0;

  /**
   * Number of items currently shown
   */
  @Input() shownItems: number = 0;

  /**
   * Number of items that will be loaded when clicking "Load More"
   */
  @Input() remainingCount: number = 0;

  /**
   * Whether the component is currently loading more items
   */
  @Input() isLoading: boolean = false;

  /**
   * Event emitted when "Load More" button is clicked
   */
  @Output() loadMore = new EventEmitter<void>();

  onLoadMore(): void {
    if (!this.isLoading) {
      this.loadMore.emit();
    }
  }
}
